import Marquee from "react-fast-marquee";

const ITEMS = [
  "Fresh Atta & Dal",
  "Pure Desi Ghee",
  "Cold Pressed Oils",
  "Authentic Indian Spices",
  "Daily Fresh Milk",
  "Quality Assured",
  "Neighbourhood Doorstep Delivery",
];

export default function EditorialMarquee() {
  return (
    <div className="bg-cream border-y border-line py-5 overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={30} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-16 font-serif italic text-lg sm:text-xl text-ink-soft/80 whitespace-nowrap">
            {item}
            <span className="text-marigold not-italic text-sm">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
